import { useRuntimeConfig } from "#imports";
import { deepmerge } from "deepmerge-ts";
export const useCollectionConfig = () => {
  const runtimeConfig = useRuntimeConfig();
  const getCollectionConfig = (collectionName = `${runtimeConfig.public.flyingkiwi.pageCollection}`) => {
    const defaults = {
      name: collectionName,
      singular: collectionName,
      plural: `${collectionName}s`,
      includeInSitemap: true,
      itemComponent: runtimeConfig.public.flyingkiwi?.components?.item,
      introComponent: runtimeConfig.public.flyingkiwi?.components?.intro,
      filterBarComponent: runtimeConfig.public.flyingkiwi?.components?.filterBar,
      paginationComponent: runtimeConfig.public.flyingkiwi?.components?.pagination,
      populate: {
        seo: {
          populate: {
            metaData: {
              populate: {
                metaImage: true
              }
            },
            openGraph: {
              populate: {
                ogImage: true
              }
            },
            markupSchema: {
              populate: {
                structuredData: true
              }
            }
          }
        },
        intro: {
          populate: {
            image: true,
            images: true,
            settings: true,
            buttons: true
          }
        },
        blocks: {
          populate: {
            image: true,
            images: true,
            settings: true,
            buttons: true,
            category: true,
            items: {
              populate: {
                buttons: true,
                image: true,
                images: true
              }
            }
          }
        }
      },
      sort: void 0
    };
    const collectionConfig = runtimeConfig.public.flyingkiwi?.collections?.find(
      (c) => {
        return c.name === collectionName;
      }
    );
    if (!collectionConfig) {
      console.warn(
        `Collection ${collectionName} not found in runtime config. Please add it to the collections array.`
      );
      return defaults;
    } else {
      return deepmerge(defaults, collectionConfig);
    }
  };
  return { getCollectionConfig, ...runtimeConfig.public.flyingkiwi };
};
